import { CommonBusinessObject, isNonNaNNumber, makeIPathToIGeofence } from '@iotv/iotv-v3-types'
import { center } from '@turf/center'
import { points } from '@turf/helpers'
import { Position as TurfPosition } from 'geojson'
import { IGeofence } from '../../ModelClassInterfaces/Geo'
import { GeofencePointsType, UserAttributeDefs } from '../../types/ModelTypes'
import { convertLatLngLocationToId } from '../../util/geo/S2/conversion'
import { convertTurfPointsToGLatLng } from '../../util/geo/TurfUtils'
import { GeoModelCommon } from './GeoModelCommon'
const debug = process.env.REACT_APP_DEBUG && false

const typeName = 'Geofence'

class Geofence extends GeoModelCommon implements IGeofence {
  constructor(ob: CommonBusinessObject & Partial<IGeofence>) {
    super({ ...ob, type: ob.type ?? typeName })
    if (!ob.points) {
      debug && console.log('Geofence assigned empty points', this)
      this.points = []
    } else {
      this.points = ob.points
    }
    if (this.points.length > 0) {
      if (this.points.length > 2) {
        makeIPathToIGeofence(this.points)
      }
      /** Turf Array has lng before lat */
      //const pArray: TurfPosition[] = this.points.filter(({ lat, lng }) => isNonNaNNumber(lat) && isNonNaNNumber(lng)).map(({ lat, lng }) => [lng, lat])
      //const xCenter: TurfPosition = center(points(pArray)).geometry.coordinates
      //this.location = convertTurfPointsToGLatLng(xCenter)
      //this.dsk = convertLatLngLocationToId(this.location, this.cellLevel)
    }
  }

  points: GeofencePointsType[]

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),

      points: {
        type: 'object',
      },
    }
  }
}

export { Geofence }
